import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { TRACK_EVENT_NAMES, TRACK_PAGE_NAMES } from 'Tracking/constants';
import { TrackPage } from 'Tracking/track-page/TrackPage';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { Button } from 'Components/frameworks/button/Button';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Image } from 'Components/frameworks/image/Image';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Hero } from 'Components/widgets/hero/Hero';
type Props = {
  config: CMSContent;
};
const ratioDisplays = [
  {
    value: 0.3,
    unit: 'rem',
  },
  {
    value: 0.3,
    unit: 'vw',
  },
  {
    value: 0.8,
    unit: 'vw',
  },
  {
    value: 0.8,
    unit: 'vw',
  },
];

const NotFoundView = ({ config }: Props) => {
  const {
    errors: { notFound },
  } = config;
  const { isTablet } = useResponsive();
  const { trackClickEvent } = useTrackEvent();
  return (
    <Fragment>
      <TrackPage pageName={TRACK_PAGE_NAMES.ERROR_404} />
      <main className="relative -mb-40 text-white sm:-mb-60" role="main">
        <Hero url={notFound.image} size="large" />
        <div className="absolute inset-0 flex w-full items-center">
          <SiteContainer className="mt-navigation pb-20">
            <h1 className="text-center font-brand text-24 leading-tight text-black sm:text-32">
              {notFound.title}
            </h1>
            <h2 className="text-center font-sans text-16 text-black">{notFound.description}</h2>
            <div className="flex justify-center">
              <Button
                className="mt-20"
                onClick={() =>
                  trackClickEvent(TRACK_EVENT_NAMES.CLICK_ERROR, {
                    detail_click: 'return_to_homepage',
                  })
                }
                url="/"
              >
                {config.common.goToHome}
              </Button>
            </div>
          </SiteContainer>
        </div>
      </main>
      <SiteContainer className="pb-60">
        <div className="mb-20 flex flex-col items-center gap-20 md:flex-row">
          {notFound.items.map((item) => (
            <DynamicLink
              className="relative isolate block w-[345px] overflow-hidden rounded-12 shadow-diffuse md:w-380"
              key={item.backgroundURL}
              url={item.link}
            >
              <Image
                dimensions={
                  isTablet
                    ? {
                        h: 380,
                        w: 380,
                      }
                    : {
                        h: 345,
                        w: 345,
                      }
                }
                imageUrl={item.backgroundURL}
                ratioDisplay={ratioDisplays}
              />
              <span className="absolute inset-0 isolate flex w-full flex-col justify-end bg-[linear-gradient(180deg,rgba(0,0,0,0)_39.4%,#2B2323_114.22%)] p-20">
                <span className="inline-flex items-center gap-10 font-sans text-20 font-bold leading-1 text-white">
                  {item.label}
                  <Icon hasRtl name={ICONS.ARROW_RIGHT} width="0.75rem" />
                </span>
              </span>
            </DynamicLink>
          ))}
        </div>
      </SiteContainer>
    </Fragment>
  );
};

NotFoundView.pageId = 'NotFound';
export default NotFoundView;
